import { render, staticRenderFns } from "./chapterMain.vue?vue&type=template&id=2582ef1e&scoped=true&"
import script from "./chapterMain.vue?vue&type=script&lang=js&"
export * from "./chapterMain.vue?vue&type=script&lang=js&"
import style0 from "./chapterMain.vue?vue&type=style&index=0&id=2582ef1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582ef1e",
  null
  
)

export default component.exports